<template>
  <div class="font-sans">
    <router-view :key="$route.fullPath"> </router-view>
    <Toaster position="bottom-right" rich-colors />
  </div>
</template>

<script>
import { Toaster } from '@boogi/ui'

export default {
  name: 'App',
  components: { Toaster },
  mounted() {
    document.title = 'Boogi Dashboard'
  },
}
</script>

<style></style>
